import React from 'react';
import { Tabs } from 'antd';

function recursiveCloneChildren(children, newProps) {
  return React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return child;
    } // Eg. String has no props


    if (child.props) {
      // @ts-ignore
      newProps.children = recursiveCloneChildren(child.props.children, newProps);
      return /*#__PURE__*/React.cloneElement(child, newProps);
    }

    return child;
  });
}

export function TabPane(_ref) {
  var {
    tab,
    key,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Tabs.TabPane, {
    tab: tab,
    key: key
  }, recursiveCloneChildren(children, {
    disabled: false
  }));
}
export function TabsWrapper(_ref2) {
  var {
    children
  } = _ref2;
  console.log(children);
  return /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "1"
  }, recursiveCloneChildren(children, {
    disabled: false
  }));
}